import * as React from 'react';
import { useRenderingOrderWithAssetsBeingMoved } from '../viewstate';
import { observer } from 'mobx-react-lite';
import TimeStreamAssetView from './TimeStreamAssetView';
import useAutoPlaceCapturedAssets from '../hooks/useAutoPlaceCapturedAssets';

export default observer(function TimeStreamAssetViews() {
    useAutoPlaceCapturedAssets();
    return (
        <>
            {useRenderingOrderWithAssetsBeingMoved().map(assetId => (
                <TimeStreamAssetView key={assetId} assetId={assetId} />
            ))}
        </>
    );
});
